module.exports = require("ramda/src/reduce");